/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import BookListDto from './BookListDto';
import PaginationModel from './PaginationModel';

/**
 * The SearchingQueryResponseModelBookListDto model module.
 * @module model/SearchingQueryResponseModelBookListDto
 * @version v1.0.0
 */
class SearchingQueryResponseModelBookListDto {
    /**
     * Constructs a new <code>SearchingQueryResponseModelBookListDto</code>.
     * @alias module:model/SearchingQueryResponseModelBookListDto
     */
    constructor() { 
        
        SearchingQueryResponseModelBookListDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SearchingQueryResponseModelBookListDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SearchingQueryResponseModelBookListDto} obj Optional instance to populate.
     * @return {module:model/SearchingQueryResponseModelBookListDto} The populated <code>SearchingQueryResponseModelBookListDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SearchingQueryResponseModelBookListDto();

            if (data.hasOwnProperty('pagination')) {
                obj['pagination'] = PaginationModel.constructFromObject(data['pagination']);
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], [BookListDto]);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/PaginationModel} pagination
 */
SearchingQueryResponseModelBookListDto.prototype['pagination'] = undefined;

/**
 * search result list
 * @member {Array.<module:model/BookListDto>} result
 */
SearchingQueryResponseModelBookListDto.prototype['result'] = undefined;






export default SearchingQueryResponseModelBookListDto;

